import React from "react";
import {
  useRouteError,
  isRouteErrorResponse,
  Link as ReactRouterLink,
} from "react-router-dom";
import { ContentLayout, Box } from "@amzn/awsui-components-react/polaris";
import Error404 from "./Error404";
import Error403 from "./Error403";
import { FORBIDDEN_403, NOT_FOUND_404 } from "../constants";
const ErrorPage = () => {
  const error = useRouteError();
  let content: React.ReactNode = null;
  if (isRouteErrorResponse(error)) {
    switch (error.status) {
      case FORBIDDEN_403:
        content = <Error403 />;
        break;
      case NOT_FOUND_404:
        content = <Error404 />;
        break;
      default:
        content = (
          <div className="centered">
            <ContentLayout>
              <Box variant="h1" textAlign="center">
                {error.status}
              </Box>
              <Box variant="h2" textAlign="center">
                {error.statusText}
              </Box>
              <Box variant="p" textAlign="center">
                {error.data}
              </Box>
              <Box variant="p" textAlign="center">
                <ReactRouterLink to="/">Nucleus Homepage</ReactRouterLink>
              </Box>
            </ContentLayout>
          </div>
        );
    }
  }
  return content;
};
export default ErrorPage;
